/* eslint-disable import/prefer-default-export */
export const NUMBER = {
  POINT_FIVE: 0.5,
  ZERO: 0,
  ONE: 1,
  TWO: 2,
  THREE: 3,
  FIVE: 5,
  FOUR: 4,
  SIX: 6,
  SEVEN: 7,
  EIGHT: 8,
  NINE: 9,
  FIFTEEN: 15,
  SIXTEEN: 16,
  EIGHTEEN: 18,
  NINETEEN: 19,
  TWENTY: 20,
  FIFTY: 50,
  THIRTY: 30,
  THIRTY_TWO: 32,
  THIRTY_SIX: 36,
  FOURTY: 40,
  FOURTY_THREE: 43,
  EIGTHY: 80,
  TWO_HUNDRED: 200,
  FIVE_HUNDRED: 500,
  ONE_HUNDRED: 100,
  ONE_THURTY: 130,
  FOUR_HUNDRED: 400,
  TWO_FIFTY: 250,
  THREE_HUNDRED: 300,
  THREE_HUNDRED_TEN: 310,
  SIX_THOUSAND: 6000,
  FIVE_THOUSAND: 5000,
  FIVE_MB: 5242880,
  TEN_MB: 10485760,
  TWO_THOUSAND: 2000,
  THOUSAND: 1000,
  TEN_LAKH: 1000000,
  FOUR_THOUSAND: 4000,
  THOUSAND_TWENTY_FOUR: 1024,
  TWELVE: 12,
  THIRTEEN: 13,
  TEN: 10,
  NEGATIVE_ONE: -1,
  ONE_TWENTY: 120,
  NINE_HUNDRED: 900,
  ONE_MB: 1024,
  NINETY_PERCENT: 0.9,
  SIXTY: 60,
  ONE_MILLION: 1000000,
  RESPONSIVE_HEIGHT: 768,
  TWENTY_FOUR: 24,
  TWENTY_THREE: 23,
  FIFTY_NINE: 59,
  SIXTY_THOUSAND: 60000,
  FOUR_HUNDRED_ONE: 401,
  POINT_SIX: 0.6,
  THIRTY_SIX_HUNDRED: 3600,
  MEDIUM_SCREEN: 786,
  FIFTY_FOUR: 54,
  ONE_THOUSAND_EIGHTY: 1080,
  MOBILE_WIDTH: 768,
  TABLET_WIDTH: 990,
  ONE_THOOUSAND_EIGHTY: 1080,
  TWO_MB: 2000000,
  TWO_SEVENTY: 270,
  ONE_FIFTY: 150,
  FOUR_EIGHTY: 480,
  SIX_HUNDRED: 600,
  NINETY: 90,
  EIGHTY_NINE: 89,
  SEVENTY: 70,
  SEVENTY_NINE: 79,
  SIXTY_NINE: 69,
  FOURTY_NINE: 49,
  THIRTY_NINE: 39,

};
